import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { propertyFinderRoutes } from './property-finder.routing';
import { RouterModule } from '@angular/router';
import {
  MatSidenavModule,
  MatListModule,
  MatTooltipModule,
  MatOptionModule,
  MatSelectModule,
  MatMenuModule,
  MatSnackBarModule,
  MatGridListModule,
  MatToolbarModule,
  MatIconModule,
  MatButtonModule,
  MatRadioModule,
  MatCheckboxModule,
  MatCardModule,
  MatProgressSpinnerModule,
  MatRippleModule,
  MatDialogModule,
  MatInputModule,
  MatAutocompleteModule,
  MatSliderModule,
} from '@angular/material';

@NgModule({
  imports: [
    MatSliderModule,
    MatAutocompleteModule,
    MatInputModule,
    MatSidenavModule,
    MatListModule,
    MatTooltipModule,
    MatOptionModule,
    MatSelectModule,
    MatMenuModule,
    MatSnackBarModule,
    MatGridListModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatRadioModule,
    MatCheckboxModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatRippleModule,
    MatDialogModule,
    CommonModule,
    RouterModule.forChild(propertyFinderRoutes),
  ],
})
export class FinderModule {}
